<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  id: { type: String, required: true },
  label: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  name: { type: String, default: undefined },
});

defineEmits(["update:modelValue", "change"]);

const uid = computed(() => props.id || `ca-checkbox-${Math.random().toString(36).slice(2)}`);
</script>

<template>
  <label class="ca-checkbox" :for="uid">
    <input
      type="checkbox"
      :id="uid"
      :name="name"
      :checked="modelValue"
      :disabled="disabled"
      @change="
        $emit('update:modelValue', $event.target.checked);
        $emit('change', $event.target.checked);
      "
    />
    <slot>{{ label }}</slot>
  </label>
</template>
